import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faTrash,
    faUserClock,
    faExclamationCircle,
    faExclamationTriangle,
    faMinusCircle,
} from '@fortawesome/free-solid-svg-icons';
import {
    FormGroup,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Input
} from 'reactstrap';
import cls from 'classnames';
import _ from 'lodash-es';
import * as moment from 'moment';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    FormCheckbox,
    FlexBetweenRow,
    FlexCenterRow,
    FlexEndRow,
    FormLabel,
    onFieldChange,
    onReactSelectChanged,
    toasty,
    FlexStartRow,
    FormBlocker,
    SmallButton
} from '../common/forms/FormElements';
import CommonContext, { ApiRoutes } from '../Common';
import SlideForm from '../common/forms/SlideForm';
import { util } from '../Util';
import { handleFormSaveError } from '../common/forms/ValidationError';
import { Timesheet } from './Timesheet';
import { ChargeTypeEligbility } from '../contracts/Contract';
import AddressFormNew from '../address/AddressFormNew';
import { Address } from '../address/Address';
import { ChargeTypeUnits } from '../chargeType/ChargeType';
import NumericInput from '../common/forms/NumericInput';
import { getTenantUserProfile } from '../common/TenantUserProfile';
import Select from 'react-select';
import './TimesheetItem.scss';

const WorkOrderType = {
    Required: 1,
    Optional: 2,
    NotApplicable: 3,
};

export default class TimesheetItem extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.addressFormRef = React.createRef();

        const stateBase = {
            jobLocationOverride: new Address(),
            addChargeDropdownOpen: false,
            timesheet: {},
            chargeTypes: [],
            materials: [],
            optionalChargeTypes: [],
            timesheetValid: false,
            visibleChargeTypeIds: [],
            saving: false,
            allowDefaultChargeTypeValues: false,
            showDeleteTimesheetModal: false,
            showTimeModal: false,
            ...new BaseFormViewModel(),
        };

        this.state = stateBase;
        this.onChange = this.onChange.bind(this);
        this.onSelectChange = this.onSelectChange.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.handleSaveError = this.handleSaveError.bind(this);
    }

    componentDidMount() { return this.populateState(); }

    onAddChargeTypeToTimesheet = (chargeType) => {
        const { optionalChargeTypes, visibleChargeTypeIds, chargeTypes } = {
            ...this.state,
        };
        const updatedChargeTypeIndex = chargeTypes.indexOf(
            chargeTypes.find((c) => c.id === chargeType.id),
        );
        _.remove(optionalChargeTypes, chargeType);
        visibleChargeTypeIds.push(chargeType.id);
        chargeTypes[updatedChargeTypeIndex].include = true;
        this.setState({
            optionalChargeTypes,
            visibleChargeTypeIds,
            chargeTypes,
        });
    };

    onAddJobLocationAddress = () => {
        const { jobLocationOverride } = { ...this.state };
        this.addressFormRef.current.open(
            false, 
            jobLocationOverride,
            'Haul To Override',
            false,
            false,
        );
    };

    // Handler for populating the same entered time values to all values of that charge type
    // ("Lazy user mode")
    onAllCheckChanged = (e) => {
        const { timesheet, chargeTypes } = this.state;

        chargeTypes.find((x) => x.name == e.target.name).sameAll = e.target.checked;

        if (e.target.checked === true) {
            const details = timesheet.timesheetDetails.filter(
                (x) => x.chargeTypeName == e.target.name,
            );
            const first = details[0];
            details.forEach((x) => {
                x.start = first.start;
                x.end = first.end;
                // Carry the full ISO datetimes over too, so every copied row
                // keeps the same date as the first one instead of losing it.
                x.startTime = first.startTime;
                x.endTime = first.endTime;
            });
        }

        this.setState({ chargeTypes, timesheet });
    };

    onChange = onFieldChange;

    onChargeChange = (resources, ev) => {
        const { timesheet } = this.state;
        const val = ev.target.value;
        const { name } = ev.target;

        // We display the options in 12-hour format, but the db has 24.
        const timeValue = ev.target.value
            ? moment(val, ['h:mm A']).format('HH:mm')
            : '';

        const timesheetDetails = timesheet.timesheetDetails.map((detail) => {
            const resource = resources.findIndex((x) => x.id === detail.id);

            if (resource === -1) {
                return detail;
            }

            return {
                ...detail,
                [name]: detail.chargeTypeUnitsId == ChargeTypeUnits.Flat || detail.chargeTypeUnitsId == ChargeTypeUnits.Tonnage ? val : timeValue,
            };
        });

        this.setState({ timesheet: { ...timesheet, timesheetDetails } });
    };

    onLoadsChange = (resources, ev) => {
        const { timesheet } = this.state;
        const val = ev.target.value;

        const timesheetDetails = timesheet.timesheetDetails.map((detail) => {
            const resource = resources.findIndex((x) => x.id === detail.id);

            if (resource === -1) {
                return detail;
            }

            detail.loads = val;

            return {
                ...detail
            };
        });

        this.setState({ timesheet: { ...timesheet, timesheetDetails } });
    }

    onMaterialChange = (resources, ev) => {
        const { timesheet } = this.state;
        const val = ev.value;

        const timesheetDetails = timesheet.timesheetDetails.map((detail) => {
            const resource = resources.findIndex((x) => x.id === detail.id);

            if (resource === -1) {
                return detail;
            }

            detail.tonnageMaterialId = val;

            return {
                ...detail
            };
        });

        this.setState({ timesheet: { ...timesheet, timesheetDetails } });
    };

    onTonnageChange = (resources, ev) => {
        const { timesheet } = this.state;
        const val = ev.target.value;
        const { name } = ev.target;

        const timesheetDetails = timesheet.timesheetDetails.map((detail) => {
            const resource = resources.findIndex((x) => x.id === detail.id);

            if (resource === -1) {
                return detail;
            }

            if (name === 'tonnageGross') {
                detail.tonnageNet = val - detail.tonnageTare
            }
            if (name === 'tonnageTare') {
                detail.tonnageNet = detail.tonnageGross - val
            }

            return {
                ...detail,
                [name]: val
            };
        });

        this.setState({ timesheet: { ...timesheet, timesheetDetails } });
    };

    onClose = () => {
        this.resetForm();
        this.props.toggleShow(false);
        this.context.setFormOpened(false);
        this.props.onClose();
    };

    onDelete = () => {
        this.setState({ showDeleteTimesheetModal: true });
    };

    toggleDeleteTimesheetModal = () => {
        const { showDeleteTimesheetModal } = {
            ...this.state,
        };

        this.setState({ showDeleteTimesheetModal: !showDeleteTimesheetModal });
    };

    onDeleteTimesheet = () => {
        const { timesheet } = {
            ...this.state,
        };

        util.fetch
            .post(ApiRoutes.timesheet.delete(), {
                timesheetId: timesheet.id
            });

        this.setState({ showDeleteTimesheetModal: false });

        this.resetForm();
        this.props.toggleShow(false);
        this.context.setFormOpened(false);
        this.props.onClose();
    };

    onRemoveChargeTypeFromTimesheet = (chargeType) => {
        const { optionalChargeTypes, visibleChargeTypeIds, chargeTypes } = {
            ...this.state,
        };
        const updatedChargeTypeIndex = chargeTypes.indexOf(
            chargeTypes.find((c) => c.id === chargeType.id),
        );
        optionalChargeTypes.push(chargeType);
        const updatedChargeTypes = visibleChargeTypeIds.filter(
            (ct) => ct !== chargeType.id,
        );
        chargeTypes[updatedChargeTypeIndex].include = false;
        this.setState({
            optionalChargeTypes,
            visibleChargeTypeIds: updatedChargeTypes,
            chargeTypes,
        });
    };

    onSaveAddress = (address) => {
        this.setState(
            (state) => (
                (state.timesheet.jobLocation = address.addressLine()), state
            ),
        );
    };

    onSelectChange = onReactSelectChanged;

    onSubmitTimesheet = async () => {
        const { saving } = { ...this.state };
        if (saving) {
            return false;
        }
        await this.setState({ saving: true });
        this.saveTimesheet();
    };

    groupTimesheetDetails = () => {
        const { timesheet } = this.state;

        const timesheetDetails = _.groupBy(
            timesheet.timesheetDetails,
            (asn) => asn.chargeTypeName,
        );

        return _.mapValues(timesheetDetails, (chargeGroup) => {
            let i = 0;
            let totalAFADs = 0;

            const len = (chargeGroup ?? []).length;

            const results = [];

            for (; i < len; i += 1) {
                const detail = chargeGroup[i];
                let description = detail.equipmentName ?? detail.employeeFullName;

                const resources = [detail];

                if (detail.equipment?.equipmentType?.equipmentTypeAFADType?.isAFAD) {
                    totalAFADs += 1;

                    if (detail.chargeType.baseConfig.numAFADsInSet > 1) {
                        // Group everything under the first item in the set and discard all other items in the set
                        const isFirstInSet = totalAFADs % detail.chargeType.baseConfig.numAFADsInSet == 1;

                        if (!isFirstInSet) {
                            continue;
                        }

                        let j = 1;

                        for (; j < detail.chargeType.baseConfig.numAFADsInSet; j += 1) {
                            const next = chargeGroup[i + j];

                            if (!next?.equipment?.equipmentType?.equipmentTypeAFADType?.isAFAD || next.isBreak !== detail.isBreak) {
                                totalAFADs = 0; // Reset counter on invalid entry
                                break;
                            }

                            description = `${description}, ${next.equipmentName}`;
                            resources.push(next);
                        }
                    }
                }

                results.push({ ...detail, resources, description });
            }

            return results;
        });
    };

    handleSaveError = (err) => handleFormSaveError(this, err);

    open = async (timesheetId) => {
        await this.setState({ loading: true });
        await this.populateState();

        const { allowDefaultChargeTypeValues } = this.state;

        let timesheet = null;

        this.resetForm();

        if (timesheetId) {
            timesheet = await util.fetch.js(
                ApiRoutes.timesheet.byId(timesheetId),
            );
        } else {
            timesheet = new Timesheet();
        }

        let materials = await util.fetch.js(
            ApiRoutes.typeAheads.timesheetMaterials(timesheet.id),
        );

        const timesheetDetails = _.groupBy(
            timesheet.timesheetDetails,
            (asn) => asn.chargeTypeName,
        );

        const chargeTypeNames = Object.keys(timesheetDetails);

        if (allowDefaultChargeTypeValues) {
            timesheet.timesheetDetails.forEach((td) => {
                if (td.chargeTypeDefaultValue && !td.value) {
                    td.value = td.chargeTypeDefaultValue;
                }
            });
        }

        const [chargeTypes, requiredChargeTypeIds, optionalChargeTypes] = [
            // Stands up same as all? functionality
            chargeTypeNames
                .map((tsd, i) => {
                    const ts = timesheetDetails[tsd][0];
                    return {
                        id: ts.chargeTypeId,
                        name: ts.chargeTypeName,
                        unitsId: ts.chargeTypeUnitsId,
                        isOptional:
                            ts.contractChargeTypeEligibilityId
                            === ChargeTypeEligbility.Optional,
                        sameAll: false,
                        include: ts.include,
                        isSurcharge: ts.isSurcharge,
                        resourceTypeId: ts.chargeType.resourceTypeId,
                    };
                })
                .filter((x) => !!x),
            // Display all required/specified charge types immediately
            chargeTypeNames
                .map((tsd, i) => {
                    if (timesheetDetails[tsd][0].include) return timesheetDetails[tsd][0].chargeTypeId;
                    return null;
                })
                .filter((x) => !!x),
            // Save optional charge types until the user adds them.
            chargeTypeNames
                .map((tsd, i) => {
                    const ts = timesheetDetails[tsd][0];
                    if (
                        !ts.include
                        && ts.contractChargeTypeEligibilityId
                            === ChargeTypeEligbility.Optional
                    ) {
                        return {
                            id: timesheetDetails[tsd][0].chargeTypeId,
                            name: timesheetDetails[tsd][0].chargeTypeName,
                        };
                    }
                    return null;
                })
                .filter((x) => !!x),
        ];

        this.setState({
            timesheet,
            chargeTypes,
            materials,
            visibleChargeTypeIds: requiredChargeTypeIds,
            optionalChargeTypes,
        });

        this.props.toggleShow(true);
        this.context.setFormOpened(true);

        await this.setState({ loading: false });
    };

    async populateState() {
        const { userTenant } = await getTenantUserProfile();
        const { tenantSettings } = { ...userTenant };
        const { allowDefaultChargeTypeValues } = tenantSettings;

        this.setState({ allowDefaultChargeTypeValues });
    }

    resetForm = () => {
        this.setState({
            formValidated: false,
        });
    };

    saveTimesheet = () => {
        const { timesheet, chargeTypes } = { ...this.state };

        timesheet.timesheetDetails = timesheet.timesheetDetails.map((d) => {
            d.include = chargeTypes.find(
                (c) => c.id === d.chargeTypeId,
            ).include;
            return d;
        });

        const setupCharges = timesheet.timesheetDetails.filter(
            (x) => x.chargeType.resourceTypeId == 5 && x.include == true && (x.isSurcharge == null || x.isSurcharge == false),
        );

        if (timesheet.contractSetupChargesRequired && setupCharges.length == 0) {
            toasty.error('Timesheet must have at least one setup charge.');
            this.setState({ saving: false });
            return;
        }

        // Copy linked charge type data over to destination timesheet detail
        var linkToChargeTypeId = 0;
        var linkFromChargeTypeId = 0;
        var startTime = '';
        var endTime = '';
        var startDateTime = null;
        var endDateTime = null;
        if (timesheet?.timesheetDetails?.length > 0) {
            for (var x = 0; x < timesheet?.timesheetDetails.length; x++) {
                if (timesheet.timesheetDetails[x].include && timesheet.timesheetDetails[x].chargeType.linkedChargeTypeId > 0) {
                    linkFromChargeTypeId = timesheet.timesheetDetails[x].chargeType.id;
                    linkToChargeTypeId = timesheet.timesheetDetails[x].chargeType.linkedChargeTypeId;
                    startTime = timesheet.timesheetDetails[x].start;
                    endTime = timesheet.timesheetDetails[x].end;
                    startDateTime = timesheet.timesheetDetails[x].startTime;
                    endDateTime = timesheet.timesheetDetails[x].endTime;
                    break;
                }
            }
        }

        if (linkFromChargeTypeId > 0 && linkToChargeTypeId > 0) {
            for (var td = 0; td < timesheet?.timesheetDetails.length; td++) {
                if (timesheet.timesheetDetails[td].chargeTypeId == linkToChargeTypeId) {
                    timesheet.timesheetDetails[td].start = startTime;
                    timesheet.timesheetDetails[td].end = endTime;
                    // Carry the full ISO datetimes over too, so the linked
                    // detail keeps the same date as its source instead of
                    // losing it on save.
                    timesheet.timesheetDetails[td].startTime = startDateTime;
                    timesheet.timesheetDetails[td].endTime = endDateTime;
                    break;
                }
            }
        }

        // The server expects full datetimes in start/end. Edited details
        // already carry datetimes; this is a safety net that expands any
        // remaining bare H:mm values (e.g. legacy data) before sending.
        // Built on a separate payload so a failed POST leaves the open form's
        // in-memory values untouched.
        var jobDateForSend = timesheet?.jobDate
            ? moment.utc(timesheet.jobDate).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD');

        var payload = {
            ...timesheet,
            timesheetDetails: timesheet.timesheetDetails.map((d) => {
                var out = { ...d };
                if (out.start && out.start.indexOf('T') === -1) {
                    out.start = out.startTime
                        ? moment(out.startTime).format('YYYY-MM-DDTHH:mm:ss')
                        : moment(jobDateForSend + ' ' + out.start, 'YYYY-MM-DD H:mm')
                            .format('YYYY-MM-DDTHH:mm:ss');
                }
                if (out.end && out.end.indexOf('T') === -1) {
                    out.end = out.endTime
                        ? moment(out.endTime).format('YYYY-MM-DDTHH:mm:ss')
                        : moment(jobDateForSend + ' ' + out.end, 'YYYY-MM-DD H:mm')
                            .format('YYYY-MM-DDTHH:mm:ss');
                }
                return out;
            }),
        };

        util.fetch
            .post(ApiRoutes.timesheet.update(), payload)
            .then((updatedTimesheet) => {
                this.setState({ timesheet: { ...updatedTimesheet } });
                toasty.success(
                    'Timesheet Saved',
                    'Timesheet updated successfully.',
                );
                this.onClose();
            })
            .catch(() => toasty.error('Error saving timesheet.'))
            .finally(() => this.setState({ saving: false }));
    };

    toggleAddChargeDropdownOpen = () => this.setState(
        (state) => (
            (state.addChargeDropdownOpen = !state.addChargeDropdownOpen),
            state
        ),
    );

    toggleDetailNotApplicable = (resources = []) => {
        const { timesheet } = this.state;

        const timesheetDetails = timesheet.timesheetDetails.map((detail) => {
            const resource = resources.findIndex((x) => x.id === detail.id);

            if (resource === -1) {
                return detail;
            }

            return {
                ...detail,
                start: '',
                end: '',
                value: 0,
                notApplicable: !detail.notApplicable,
            };
        });

        this.setState({ timesheet: { ...timesheet, timesheetDetails } });
    };

    onStartTimeClicked = (e, detail) => {
        var rounded = moment();
        const remainder = rounded.minutes() % 15;

        if (remainder !== 0) {
            if (remainder <= 7) { // Round down
                rounded.subtract(remainder, 'minutes');
            } else { // Round up
                rounded.add(15 - remainder, 'minutes');
            }
        }

        // Read whatever the detail carries: prefer the full ISO datetime in
        // startTime; fall back to the HH:mm string in start. The date comes
        // from startTime when present, otherwise the timesheet's job date.
        // Parse with UTC to avoid timezone shifts changing the calendar day.
        var { timesheet } = this.state;
        var selectedHour;
        var selectedMinutes;
        var selectedAMPM;
        var selectedDate;

        if (detail?.startTime) {
            // Match onSubmitTime's local, no-conversion write (see endTime note).
            var st = moment(detail.startTime);
            selectedHour = parseInt(st.format('h'));
            selectedMinutes = parseInt(st.format('mm'));
            selectedAMPM = st.format('A');
            selectedDate = st.format('YYYY-MM-DD');
        } else if (detail?.start) {
            // The backend now stores start as a full datetime (it used to be an
            // HH:mm string). Parse it as a datetime so we can recover the real
            // calendar day (job date vs job date + 1) for the dropdown. Fall
            // back to HH:mm parsing for any legacy time-only values.
            var sh = moment(detail.start, [moment.ISO_8601, 'YYYY-MM-DDTHH:mm:ss', 'HH:mm', 'H:mm'], true);
            if (!sh.isValid()) {
                sh = moment(detail.start);
            }
            selectedHour = parseInt(sh.format('h'));
            selectedMinutes = parseInt(sh.format('mm'));
            selectedAMPM = sh.format('A');
            // If the parsed value carries a date (datetime), use that day;
            // otherwise it was time-only, so default to the job date.
            selectedDate = (typeof detail.start === 'string' && detail.start.indexOf('T') !== -1)
                ? sh.format('YYYY-MM-DD')
                : (timesheet?.jobDate
                    ? moment.utc(timesheet.jobDate).format('YYYY-MM-DD')
                    : moment().format('YYYY-MM-DD'));
        } else {
            selectedHour = parseInt(rounded.format('h'));
            selectedMinutes = parseInt(rounded.format('mm'));
            selectedAMPM = rounded.format('A');
            selectedDate = timesheet?.jobDate
                ? moment.utc(timesheet.jobDate).format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD');
        }

        // Snap to one of the two canonical option strings (jobDate or
        // jobDate+1) so the dropdown's bound value and this state value can
        // never diverge — same logic as the end side.
        var jobDateStrNormS = timesheet?.jobDate
            ? moment.utc(timesheet.jobDate).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD');
        var nextDateStrNormS = moment(jobDateStrNormS).add(1, 'day').format('YYYY-MM-DD');
        selectedDate = selectedDate === nextDateStrNormS ? nextDateStrNormS : jobDateStrNormS;

        this.setState({
            showTimeModal: true,
            selectedHour: selectedHour,
            selectedMinutes: selectedMinutes,
            selectedDate: selectedDate,
            selectedDetail: detail,
            startTime: true,
            AMPM: selectedAMPM
        });
    }

    onEndTimeClicked = (e, detail) => {

        var rounded = moment();
        const remainder = rounded.minutes() % 15;

        if (remainder !== 0) {
            if (remainder <= 7) { // Round down
                rounded.subtract(remainder, 'minutes');
            } else { // Round up
                rounded.add(15 - remainder, 'minutes');
            }
        }

        // Read whatever the detail carries: prefer the full ISO datetime in
        // endTime; fall back to the HH:mm string in end. The date comes
        // from endTime when present, otherwise the timesheet's job date.
        // Parse with UTC to avoid timezone shifts changing the calendar day.
        var { timesheet } = this.state;
        var selectedHour;
        var selectedMinutes;
        var selectedAMPM;
        var selectedDate;

        if (detail?.endTime) {
            // Read with the same (local, no-conversion) interpretation that
            // onSubmitTime uses when it writes endTime. Parsing with
            // moment.utc here would shift the calendar day by the local UTC
            // offset and make a jobDate+1 pick read back as jobDate.
            var et = moment(detail.endTime);
            selectedHour = parseInt(et.format('h'));
            selectedMinutes = parseInt(et.format('mm'));
            selectedAMPM = et.format('A');
            selectedDate = et.format('YYYY-MM-DD');
        } else if (detail?.end) {
            // The backend now stores end as a full datetime. Parse it as a
            // datetime so we can recover the real calendar day for the
            // dropdown (job date vs job date + 1) instead of inferring it.
            var endIsDateTime = (typeof detail.end === 'string' && detail.end.indexOf('T') !== -1);
            var eh = moment(detail.end, [moment.ISO_8601, 'YYYY-MM-DDTHH:mm:ss', 'HH:mm', 'H:mm'], true);
            if (!eh.isValid()) {
                eh = moment(detail.end);
            }
            selectedHour = parseInt(eh.format('h'));
            selectedMinutes = parseInt(eh.format('mm'));
            selectedAMPM = eh.format('A');

            var jobDateStr = timesheet?.jobDate
                ? moment.utc(timesheet.jobDate).format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD');

            if (endIsDateTime) {
                // Datetime carries its own day — use it directly.
                selectedDate = eh.format('YYYY-MM-DD');
            } else {
                // Legacy time-only value: infer the end date by comparing to
                // the start time. If end is earlier than start, the entry
                // crossed midnight, so the end date is the day after job date.
                var crossesMidnight = false;
                if (detail?.start) {
                    var startIsDateTime = (typeof detail.start === 'string' && detail.start.indexOf('T') !== -1);
                    var sh2 = startIsDateTime
                        ? moment(detail.start)
                        : moment(detail.start, ['HH:mm', 'H:mm']);
                    // Compare time-of-day only.
                    var ehTod = moment(eh.format('HH:mm'), 'HH:mm');
                    var shTod = moment(sh2.format('HH:mm'), 'HH:mm');
                    if (ehTod.isBefore(shTod)) {
                        crossesMidnight = true;
                    }
                }
                selectedDate = crossesMidnight
                    ? moment(jobDateStr).add(1, 'day').format('YYYY-MM-DD')
                    : jobDateStr;
            }
        } else {
            selectedHour = parseInt(rounded.format('h'));
            selectedMinutes = parseInt(rounded.format('mm'));
            selectedAMPM = rounded.format('A');
            selectedDate = timesheet?.jobDate
                ? moment.utc(timesheet.jobDate).format('YYYY-MM-DD')
                : moment().format('YYYY-MM-DD');
        }

        // Snap to one of the two canonical option strings (jobDate or
        // jobDate+1) so the dropdown's bound value and this state value can
        // never diverge. Without this, a value that isn't an exact match for
        // either option causes the dropdown to display jobDate while state
        // holds something else, and the user's picked date is lost on save.
        var jobDateStrNorm = timesheet?.jobDate
            ? moment.utc(timesheet.jobDate).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD');
        var nextDateStrNorm = moment(jobDateStrNorm).add(1, 'day').format('YYYY-MM-DD');
        selectedDate = selectedDate === nextDateStrNorm ? nextDateStrNorm : jobDateStrNorm;

        this.setState({
            showTimeModal: true,
            selectedHour: selectedHour,
            selectedMinutes: selectedMinutes,
            selectedDate: selectedDate,
            selectedDetail: detail,
            startTime: false,
            AMPM: selectedAMPM
        });
    }

    onIncrementHours = (e) => {
        var { selectedHour } = { ...this.state };

        selectedHour++;

        if (selectedHour > 12)
            selectedHour = 1

        this.setState({
            selectedHour
        });
    }

    onDecrementHours = (e) => {
        var { selectedHour } = { ...this.state };

        selectedHour--;

        if (selectedHour <= 0)
            selectedHour = 12;

        this.setState({
            selectedHour
        });
    }

    onIncrementMinutes = (e) => {
        var { selectedMinutes } = { ...this.state };

        selectedMinutes += 15;

        if (selectedMinutes > 45)
            selectedMinutes = 0

        this.setState({
            selectedMinutes
        });
    }

    onDecrementMinutes = (e) => {
        var { selectedMinutes } = { ...this.state };

        selectedMinutes -= 15;

        if (selectedMinutes < 0)
            selectedMinutes = 45;

        this.setState({
            selectedMinutes
        });
    }

    onCancelTime = async () => {
        await this.setState({
            showTimeModal: false,
        });
    }

    onClearTime = async () => {
        var { timesheet, selectedDetail } = { ...this.state };

        // The Clear button wipes the entire entry (both start and end),
        // regardless of which side opened the modal. Null out both the
        // ISO datetime fields and the HH:mm string fields so nothing
        // stale lingers on the detail.
        for (var i = 0; i < timesheet.timesheetDetails.length; i++) {
            if (timesheet.timesheetDetails[i].id == selectedDetail.id) {
                timesheet.timesheetDetails[i].startTime = null;
                timesheet.timesheetDetails[i].endTime = null;
                timesheet.timesheetDetails[i].start = null;
                timesheet.timesheetDetails[i].end = null;
            }
        }


        await this.setState({
            showTimeModal: false,
            timesheet
        });
    }

    onResetTime = (selectedDetail) => {
        var { timesheet } = { ...this.state };

        for (var i = 0; i < timesheet.timesheetDetails.length; i++) {
            if (timesheet.timesheetDetails[i].id == selectedDetail.id) {
                timesheet.timesheetDetails[i].startTime = null;
                timesheet.timesheetDetails[i].endTime = null;
                timesheet.timesheetDetails[i].start = null;
                timesheet.timesheetDetails[i].end = null;
            }
        }

        this.setState({
            timesheet
        });
    }

    // Resolve a detail's start or end to a full moment datetime, handling the
    // three shapes the data can take: a full datetime in start/end (current
    // backend), a separate startTime/endTime ISO field, or a legacy HH:mm
    // string (in which case the date is taken from jobDate, with an optional
    // +1 day for an end that crosses midnight).
    resolveDetailDateTime = (detail, which) => {
        var jobDateStr = this.state.timesheet?.jobDate
            ? moment.utc(this.state.timesheet.jobDate).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD');

        var rawTime = which === 'start' ? detail?.startTime : detail?.endTime;
        var raw = which === 'start' ? detail?.start : detail?.end;

        if (rawTime) {
            return moment(rawTime);
        }
        if (raw) {
            var isDateTime = (typeof raw === 'string' && raw.indexOf('T') !== -1);
            if (isDateTime) {
                return moment(raw);
            }
            // Legacy HH:mm.
            var tod = moment(raw, ['HH:mm', 'H:mm']);
            var dateStr = jobDateStr;
            if (which === 'end' && detail?.start) {
                var startIsDt = (typeof detail.start === 'string' && detail.start.indexOf('T') !== -1);
                var sTod = startIsDt
                    ? moment(moment(detail.start).format('HH:mm'), 'HH:mm')
                    : moment(detail.start, ['HH:mm', 'H:mm']);
                if (moment(tod.format('HH:mm'), 'HH:mm').isBefore(sTod)) {
                    dateStr = moment(jobDateStr).add(1, 'day').format('YYYY-MM-DD');
                }
            }
            return moment(dateStr + ' ' + tod.format('HH:mm'), 'YYYY-MM-DD HH:mm');
        }
        return null;
    };

    onSubmitTime = async () => {
        var { timesheet, selectedHour, selectedMinutes, selectedDate, selectedDetail, AMPM, startTime } = { ...this.state };

        var time = selectedHour + ':' + selectedMinutes + ' ' + AMPM;
        var newTime = moment(time, 'h:m a');

        // Validate start vs. end based on the FULL datetime (date + time), so
        // that a midnight-crossing entry (end-of-day < start-of-day on the
        // next date) is allowed, but a same-date or backwards entry is not.
        // Both start and end use whatever date the user picked in the dropdown
        // (selectedDate).
        var jobDateStr = timesheet?.jobDate
            ? moment.utc(timesheet.jobDate).format('YYYY-MM-DD')
            : moment().format('YYYY-MM-DD');

        if (startTime) {
            // Submitting the start time. Compare against the existing end's
            // resolved datetime, if one exists.
            var existingEndFull = this.resolveDetailDateTime(selectedDetail, 'end');
            if (existingEndFull) {
                var newStartDateStr = selectedDate || jobDateStr;
                var newStartFull = moment(
                    newStartDateStr + ' ' + newTime.format('H:mm'),
                    'YYYY-MM-DD H:mm',
                );
                if (!existingEndFull.isAfter(newStartFull)) {
                    toasty.error('Start time must be before the end time.');
                    return;
                }
            }
        } else {
            // Submitting the end time. Compare against the existing start's
            // resolved datetime, if one exists.
            var existingStartFull = this.resolveDetailDateTime(selectedDetail, 'start');
            if (existingStartFull) {
                var endDateStr2 = selectedDate || jobDateStr;
                var newEndFull = moment(
                    endDateStr2 + ' ' + newTime.format('H:mm'),
                    'YYYY-MM-DD H:mm',
                );
                if (!newEndFull.isAfter(existingStartFull)) {
                    toasty.error('End time must be after the start time.');
                    return;
                }
            }
        }

        // Both sides honor the date the user picked in the dropdown
        // (selectedDate); fall back to the job date if unset. Stored as
        // wall-clock with no UTC conversion.
        var startDateForSave = selectedDate || jobDateStr;
        var endDateForSave = selectedDate || jobDateStr;

        for (var i = 0; i < timesheet.timesheetDetails.length; i++) {
            var d = timesheet.timesheetDetails[i];
            // Update the edited parent and any child loads pointing at it, so
            // loads stay in sync with the parent's date/time.
            var isTarget =
                d.id == selectedDetail.id ||
                d.parentTimesheetDetailId == selectedDetail.id;
            if (isTarget) {
                if (startTime) {
                    var startFull = moment(
                        startDateForSave + ' ' + newTime.format('H:mm'),
                        'YYYY-MM-DD H:mm',
                    ).format('YYYY-MM-DDTHH:mm:ss');
                    // start now carries the full datetime (matches the backend
                    // contract); startTime kept in sync for any legacy readers.
                    d.start = startFull;
                    d.startTime = startFull;
                }
                else {
                    var endFull = moment(
                        endDateForSave + ' ' + newTime.format('H:mm'),
                        'YYYY-MM-DD H:mm',
                    ).format('YYYY-MM-DDTHH:mm:ss');
                    d.end = endFull;
                    d.endTime = endFull;
                }
            }
        }


        await this.setState({
            showTimeModal: false,
            timesheet
        });
    }

    onAMPM = (selected) => {
        var { AMPM } = { ...this.state };

        if (selected == 'AM') AMPM = 'AM';
        else if (selected == 'PM') AMPM = 'PM';

        this.setState({
            AMPM
        });
    }

    onAddHourlyLoad = async () => {
        const { timesheet } = this.state;

        var parentDetail = timesheet.timesheetDetails.filter((x) => x.parentTimesheetDetailId == 0
            && x.chargeTypeUnitsId == 1
            && x.equipmentId > 0);

        var children = timesheet.timesheetDetails.filter((x) => x.parentTimesheetDetailId > 0
            && x.chargeTypeUnitsId == 1
            && x.equipmentId > 0);

        if (parentDetail.length > 0) {
            var newDetail = util.object.clone(parentDetail[0]);

            newDetail.id = children.length * -1;
            newDetail.parentTimesheetDetailId = parentDetail[0].id;
            newDetail.value = 0;
            newDetail.loads = 1;

            timesheet.timesheetDetails.push(newDetail);

            await this.setState({
                timesheet
            });
        }
    }

    onDeleteHourlyDetail = async (detail) => {
        const { timesheet } = this.state;

        var newDetails = timesheet.timesheetDetails.filter((x) => x.id != detail.id);
        timesheet.timesheetDetails = newDetails;

        await this.setState({
            timesheet
        });
    }

    render() {
        const {
            chargeTypes,
            materials,
            formValidated,
            timesheet,
            validationMessage,
            saving,
            loading,
            errors,
            showDeleteTimesheetModal,
            showTimeModal,
            AMPM
        } = this.state;

        if (!timesheet) {
            return null;
        }

        const timesheetDetails = this.groupTimesheetDetails();

        const wonPlaceholder = timesheet.workOrderTypeId === WorkOrderType.Required
            ? '(Required)'
            : '(Optional)';
        const disabled = !!timesheet.isComplete;
        const notesLength = ((timesheet ?? {}).notes ?? '').length;

        const sequence = timesheet.linkedTimesheetSequence == null ? '' : '-' + timesheet.linkedTimesheetSequence;

        var hasTonnageEquipmentCharges = false;

        var linkedChargeTypeId = 0;
        if (timesheet?.timesheetDetails?.length > 0) {
            for (var i = 0; i < timesheet?.timesheetDetails.length; i++) {
                if (timesheet.timesheetDetails[i].chargeTypeUnitsName == 'Tonnage' && timesheet.timesheetDetails[i].contractChargeTypeEligibilityId == 1) {
                    hasTonnageEquipmentCharges = true;
                    break;
                }
            }

            for (var x = 0; x < timesheet?.timesheetDetails.length; x++) {
                if (timesheet.timesheetDetails[x].chargeType.linkedChargeTypeId > 0) {
                    linkedChargeTypeId = timesheet.timesheetDetails[x].chargeType.linkedChargeTypeId;
                    break;
                }
            }
        }

        return (
            <>
                <SlideForm
                    loading={loading}
                    show={this.props.show}
                    id="timesheetItem"
                    formIcon={faUserClock}
                    formTitle={
                        !!parseInt((timesheet ?? {}).id ?? 0) > 0
                            ? 'Edit Ticket'
                            : 'Add Ticket'
                    }
                    ref={this.formRef}
                    setIsValidated={(value) => {
                        this.setState({ formValidated: value });
                    }}
                    isValidated={formValidated}
                    onSubmit={this.onSubmitTimesheet}
                    onClose={this.onClose}
                    onSave={this.saveTimesheet}
                    onDelete={this.onDelete}
                    errors={errors}
                    onClearErrors={this.onClearErrors}
                    validationMessage={validationMessage}
                    readOnly={disabled}
                    showDelete={timesheet?.linkedTimesheetId > 0}
                >
                    <FormBlocker show={!!saving} showProgress />
                    <div className="timesheetDetails">
                        <h5 className="d-flex flex-row align-items-center text-muted justify-content-center">
                            {`${timesheet.customerName}${
                                timesheet.subcontractorName
                                    ? ` - ${timesheet.subcontractorName}`
                                    : ''
                            } - ${timesheet.jobNumber}${sequence}` }
                        </h5>

                        <div id="validationMessages" className="pt-2 pb-2">
                            <small className="text-danger">
                                <FontAwesomeIcon
                                    icon={faExclamationCircle}
                                    size="lg"
                                    className="mr-1"
                                />
                Your submission contains invalid entries.
                            </small>
                        </div>
                        {!!timesheet.isComplete && (
                            <div className="site-alert site-alert-success text-center">
              This timesheet was completed.
                            </div>
                        )}
                        <FlexBetweenRow>
                            {hasTonnageEquipmentCharges && (
                                <FormGroup>
                                    <FormLabel
                                        required={
                                            timesheet.workOrderTypeId
                                                == WorkOrderType.Required
                                        }
                                        htmlFor="workOrderNumberTimesheet"
                                        text="Scale Ticket #"
                                    />
                                    <FlexStartRow>
                                        <input
                                            placeholder={wonPlaceholder}
                                            disabled={disabled}
                                            id="workOrderNumberTimesheet"
                                            required={
                                                timesheet.workOrderTypeId
                                                    == WorkOrderType.Required
                                            }
                                            name="timesheet.workOrderNumber"
                                            className={cls(
                                                'form-control form-control-sm',
                                            )}
                                            value={
                                                timesheet.workOrderNumber
                                                    ?? ''
                                            }
                                            onChange={(ev) => {
                                                const { value } = ev.target;
                                                this.setState(
                                                    (state) => (
                                                        (state.timesheet.workOrderNumber = value),
                                                        state
                                                    ),
                                                );
                                            }}
                                        />
                                    </FlexStartRow>
                                </FormGroup>
                            )}
                            {/*{!!optionalChargeTypes.length*/}
                            {/*    && !timesheet.isComplete && (*/}
                            {/*    <FormGroup>*/}
                            {/*        <label*/}
                            {/*            className="control-label"*/}
                            {/*            style={{ opacity: 0 }}*/}
                            {/*        >*/}
                            {/*        Add Charge*/}
                            {/*        </label>*/}
                            {/*        <Dropdown*/}
                            {/*            isOpen={addChargeDropdownOpen}*/}
                            {/*            toggle={*/}
                            {/*                this.toggleAddChargeDropdownOpen*/}
                            {/*            }*/}
                            {/*        >*/}
                            {/*            <DropdownToggle*/}
                            {/*                size="sm"*/}
                            {/*                id="addChargeDropdown"*/}
                            {/*                color="outline-primary"*/}
                            {/*            >*/}
                            {/*                <i className="fa fa-plus-circle fa-lg mr-1" />*/}
                            {/*          Add Charge*/}
                            {/*            </DropdownToggle>*/}
                            {/*            <DropdownMenu className="shadow">*/}
                            {/*                {optionalChargeTypes.map((ct) => (*/}
                            {/*                    <DropdownItem*/}
                            {/*                        key={ct.id}*/}
                            {/*                        className="cursor-pointer"*/}
                            {/*                        onClick={() => this.onAddChargeTypeToTimesheet(*/}
                            {/*                            ct,*/}
                            {/*                        )}*/}
                            {/*                    >*/}
                            {/*                        {ct.name}*/}
                            {/*                    </DropdownItem>*/}
                            {/*                ))}*/}
                            {/*            </DropdownMenu>*/}
                            {/*        </Dropdown>*/}
                            {/*    </FormGroup>*/}
                            {/*)}*/}
                        </FlexBetweenRow>
                        <FlexStartRow>
                            <FormGroup className="w-100">
                                <FormLabel
                                    htmlFor="meetingLocation"
                                    text="Haul From Override"
                                />

                                <input
                                    disabled={disabled}
                                    id="meetingLocation"
                                    name="timesheet.meetingLocation"
                                    className={cls(
                                        'form-control form-control-sm',
                                    )}
                                    value={timesheet.meetingLocation ?? ''}
                                    onChange={(ev) => {
                                        const { value } = ev.target;
                                        this.setState(
                                            (state) => (
                                                (state.timesheet.meetingLocation = value),
                                                state
                                            ),
                                        );
                                    }}
                                />
                            </FormGroup>
                        </FlexStartRow>
                        <FlexStartRow>
                            <FormGroup className="w-100">
                                <FormLabel
                                    htmlFor="jobLocation"
                                    text="Haul To Override"
                                />

                                <input
                                    disabled={disabled}
                                    id="jobLocation"
                                    name="timesheet.jobLocation"
                                    className={cls(
                                        'form-control form-control-sm',
                                    )}
                                    value={timesheet.jobLocation ?? ''}
                                    onChange={(ev) => {
                                        const { value } = ev.target;
                                        this.setState(
                                            (state) => (
                                                (state.timesheet.jobLocation = value),
                                                state
                                            ),
                                        );
                                    }}
                                />
                            </FormGroup>
                        </FlexStartRow>

                        {!hasTonnageEquipmentCharges &&
                            <FlexEndRow>
                                <SmallButton
                                    type="button"
                                    className="ml-1"
                                    title=""
                                    onClick={(e) => this.onAddHourlyLoad()}
                                >
                                    <i className="fa fa-plus-circle fa-lg mr-1" />
                                    Add Load
                                </SmallButton>
                            </FlexEndRow>
                        }

                        {!!chargeTypes
                            && chargeTypes.map(
                                (chargeType) => !!chargeType.include
                                    && !chargeType.isSurcharge && chargeType.id !== linkedChargeTypeId && (
                                    <div
                                        key={chargeType.name}
                                        className="crewTimesheetDetails table-responsive"
                                    >
                                        <FlexBetweenRow>
                                            <span className="pl-1 timesheetHeader text-muted">
                                                {chargeType.name}

                                                {/*{chargeType.id === 1 && ( // min charge type is 1*/}
                                                {/*    <FontAwesomeIcon*/}
                                                {/*        icon={*/}
                                                {/*            faExclamationCircle*/}
                                                {/*        }*/}
                                                {/*        title="Minimum charge type from cancellation"*/}
                                                {/*        className="text-danger ml-2 cursor-pointer"*/}
                                                {/*    />*/}
                                                {/*)}*/}
                                                {
                                                    // Only allow optional charge types to be removed once added.
                                                    !!chargeType.isOptional && (
                                                        <FontAwesomeIcon
                                                            icon={
                                                                faMinusCircle
                                                            }
                                                            title="Remove this charge type"
                                                            className="text-danger ml-2 cursor-pointer"
                                                            onClick={() => this.onRemoveChargeTypeFromTimesheet(
                                                                chargeType,
                                                            )}
                                                        />
                                                    )
                                                }
                                            </span>
                                            {!timesheet.isComplete
                                                    && chargeType.id !== 1
                                                    && chargeType.resourceTypeId != 5 && false && (
                                                <FormCheckbox
                                                    small
                                                    className="m-1"
                                                    id={`${chargeType.name}`}
                                                    name={`${chargeType.name}`}
                                                    checked={
                                                        chargeType.sameAll
                                                    }
                                                    onChange={
                                                        this
                                                            .onAllCheckChanged
                                                    }
                                                    labelText="Same For All?"
                                                />
                                            )}
                                            {chargeType.resourceTypeId == 5
                                                    && <div style={{ height: '25px' }}>&nbsp;</div>}
                                        </FlexBetweenRow>
                                        <table className="table table-sm crewTimesheetTable borderless">
                                            {chargeType.resourceTypeId != 5
                                                    && (
                                                        <thead>
                                                            <tr>
                                                                <th />
                                                                <th className="not-applicable" />
                                                                <th className="not-applicable">
                                                          CLEAR
                                                                </th>
                                                                {(chargeType.unitsId === ChargeTypeUnits.Flat || chargeType.unitsId === ChargeTypeUnits.Tonnage) ? (
                                                                    <th className="units-value" />
                                                                ) : (
                                                                    <>
                                                                        <th className="start-time">
                                                            START
                                                                        </th>
                                                                        <th className="end-time">
                                                            STOP
                                                                        </th>
                                                                    </>
                                                                )}
                                                            </tr>
                                                        </thead>
                                                    )}
                                            <tbody>
                                                {timesheetDetails[
                                                    chargeType.name
                                                ].map(
                                                    (
                                                        detail,
                                                        detailIndex,
                                                    ) => {
                                                        let timeSpan = 0.0;
                                                        let chargeExceedsThreshold = false;
                                                        let breakExceedsThreshold = false;

                                                        if (
                                                            detail.startTime
                                                                && detail.endTime
                                                                && (detail.hoursExceededThreshold
                                                                    > 0
                                                                    || detail.breakHoursExceededThreshold
                                                                        > 0)
                                                        ) {
                                                            const start = moment.utc(
                                                                detail.startTime,
                                                            );
                                                            const end = moment.utc(
                                                                detail.endTime,
                                                            );
                                                            const dur = moment.duration(
                                                                end.diff(
                                                                    start,
                                                                ),
                                                            );

                                                            timeSpan = dur._data
                                                                .hours
                                                                    + (dur._data
                                                                        .minutes
                                                                    > 0
                                                                        ? dur
                                                                            ._data
                                                                            .minutes
                                                                          / 60
                                                                        : 0);

                                                            chargeExceedsThreshold = !detail.isBreak
                                                                    && detail.hoursExceededThreshold
                                                                        > 0
                                                                    && timeSpan
                                                                        >= detail.hoursExceededThreshold;

                                                            breakExceedsThreshold = detail.isBreak
                                                                    && detail.breakHoursExceededThreshold
                                                                        > 0
                                                                    && timeSpan
                                                                        >= detail.breakHoursExceededThreshold;
                                                        }

                                                        return (
                                                            <>
                                                                <tr
                                                                    key={
                                                                        detail.id
                                                                    }
                                                                    
                                                                >
                                                                    {detail.parentTimesheetDetailId == 0 &&
                                                                        <>
                                                                            <td>
                                                                                <small>
                                                                                    {detail.description}
                                                                                </small>
                                                                            </td>
                                                                            <td className="not-applicable">
                                                                                {chargeExceedsThreshold && (
                                                                                    <i
                                                                                        title="Hours Exceed Suggested Threshold"
                                                                                        className="fa fa-exclamation-triangle text-warning mr-1"
                                                                                    />
                                                                                )}
                                                                                {breakExceedsThreshold && (
                                                                                    <i
                                                                                        title="Hours Exceed Suggested Threshold"
                                                                                        className="fa fa-exclamation-triangle text-warning mr-1"
                                                                                    />
                                                                                )}
                                                                            </td>
                                                                            <td className="not-applicable">
                                                                                {chargeType.resourceTypeId != 5
                                                                                        && (
                                                                                            <FontAwesomeIcon
                                                                                                size="lg"
                                                                                                style={{ color: 'darkgray' }}
                                                                                                className={cls(
                                                                                                    'cursor-pointer icon-check',
                                                                                                    {
                                                                                                        checked:
                                                                                                            detail.notApplicable,
                                                                                                    },
                                                                                                )}
                                                                                                icon={
                                                                                                    faTrash
                                                                                                }
                                                                                                title="Reset times"
                                                                                                onClick={() => {
                                                                                                    this.onResetTime(detail);
                                                                                                }}
                                                                                            />
                                                                                        )}
                                                                            </td>
                                                                    

                                                                            {detail.chargeTypeUnitsId === ChargeTypeUnits.Flat ? (
                                                                                <td className="units-value">
                                                                                    <NumericInput
                                                                                        className="form-control form-control-sm"
                                                                                        name="value"
                                                                                        disabled={
                                                                                            !!detail.notApplicable
                                                                                            || disabled
                                                                                            || detail.timesheetDetailStatusId
                                                                                                === 4
                                                                                        }
                                                                                        value={
                                                                                            detail.value
                                                                                            ?? ''
                                                                                        }
                                                                                        onChange={(
                                                                                            ev,
                                                                                        ) => this.onChargeChange(
                                                                                            detail.resources,
                                                                                            ev,
                                                                                        )}
                                                                                        min={0}
                                                                                        max={detail.resources.length > 1 ? 1 : undefined}
                                                                                        placeholder="Enter value"
                                                                                        type="number"
                                                                                        step={
                                                                                            detail.chargeTypeIncrement
                                                                                            ?? 1
                                                                                        }
                                                                                    />
                                                                                </td>
                                                                            ) : (
                                                                                <>
                                                                                    <td className="start-time">
                                                                                        <input
                                                                                            readOnly={true}
                                                                                            name="start"
                                                                                            value={
                                                                                                detail?.startTime
                                                                                                    ? moment(detail.startTime).format('h:mm a')
                                                                                                    : detail?.start
                                                                                                        ? (typeof detail.start === 'string' && detail.start.indexOf('T') !== -1
                                                                                                            ? moment(detail.start).format('h:mm a')
                                                                                                            : moment(detail.start, ['H:mm', 'HH:mm']).format('h:mm a'))
                                                                                                        : ''
                                                                                            }
                                                                                            style={{ width: '70px', backgroundColor: '#F0F0F0', border: 0 }}
                                                                                            onClick={(e) => this.onStartTimeClicked(e, detail) }
                                                                                        />
                                                                                    </td>
                                                                                    <td className="end-time">
                                                                                        <input
                                                                                            readOnly={true}
                                                                                            name="end"
                                                                                            value={
                                                                                                detail?.endTime
                                                                                                    ? moment(detail.endTime).format('h:mm a')
                                                                                                    : detail?.end
                                                                                                        ? (typeof detail.end === 'string' && detail.end.indexOf('T') !== -1
                                                                                                            ? moment(detail.end).format('h:mm a')
                                                                                                            : moment(detail.end, ['H:mm', 'HH:mm']).format('h:mm a'))
                                                                                                        : ''
                                                                                            }
                                                                                            style={{ width: '70px', backgroundColor: '#F0F0F0', border: 0 }}
                                                                                            onClick={(e) => this.onEndTimeClicked(e, detail)}
                                                                                        />
                                                                                    </td>
                                                                                </>
                                                                            )}
                                                                        </>
                                                                    }
                                                                </tr>
                                                                
                                                                {detail.chargeTypeUnitsId === ChargeTypeUnits.Hours && (
                                                                    <>
                                                                        <tr>
                                                                            <td>
                                                                                <table style={{ width: '100%', border: 0 }}>
                                                                                    <tr style={{ border: 0 }}>
                                                                                        <td style={{ fontSize: '12px', paddingTop: '12px', border: 0 }}>#&nbsp;Loads</td>
                                                                                        <td style={{ border: 0 }}>
                                                                                            <input
                                                                                                disabled={disabled}
                                                                                                id="loads"
                                                                                                name="loads"
                                                                                                className={cls(
                                                                                                    'form-control form-control',
                                                                                                )}
                                                                                                style={{ textAlign: 'right', width: '40px' }}
                                                                                                value={
                                                                                                    detail.loads
                                                                                                    ?? '0'
                                                                                                }
                                                                                                onFocus={(e) => {
                                                                                                    e.currentTarget.select();
                                                                                                }}
                                                                                                onChange={(
                                                                                                    ev,
                                                                                                ) => this.onLoadsChange(
                                                                                                    detail.resources,
                                                                                                    ev,
                                                                                                )}
                                                                                            />
                                                                                        </td>                                                               
                                                                                    </tr>
                                                                                </table>
  
                                                                            </td>
                                                                            <td colspan="4">
                                                                                <table style={{ width: '100%', border: 0 }}>
                                                                                    <tr style={{ border: 0 }}>
                                                                                        <td style={{ border: 0 }}>
                                                                                            <Select
                                                                                                style={{ zIndex: 9999 }}
                                                                                                menuPortalTarget={document.body}
                                                                                                id="tonnageMaterialId"
                                                                                                name="tonnageMaterialId"
                                                                                                placeholder='Material...'
                                                                                                options={materials}
                                                                                                value={(materials ?? []).find((s) => s.value === detail.tonnageMaterialId) ?? ''}
                                                                                                onChange={(
                                                                                                    ev,
                                                                                                ) => this.onMaterialChange(
                                                                                                    detail.resources,
                                                                                                    ev,
                                                                                                )}
                                                                                            >
                                                                                            </Select>
                                                                                        </td>
                                                                                        
                                                                                        <td style={{ border: 0, width: '30px', paddingTop: '12px' }} align="center" valign="middle">
                                                                                            {detail.parentTimesheetDetailId > 0 &&
                                                                                                <span 
                                                                                                    className="fa fa-times fa-lg cursor-pointer"
                                                                                                    onClick={() => {
                                                                                                        this.onDeleteHourlyDetail(detail);
                                                                                                    }}
                                                                                                />
                                                                                            }
                                                                                        </td>
                                                                                        
                                                                                    </tr>
                                                                                </table>
                                                                                
                                                                                
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )}

                                                                {detail.chargeTypeUnitsId === ChargeTypeUnits.Tonnage && (
                                                                    <>
                                                                        <tr>
                                                                            <td>&nbsp;</td>
                                                                            <td>&nbsp;</td>
                                                                            <td colspan='3'>
                                                                                <div style={{ height: '10px' }}>&nbsp;</div>
                                                                                <Select
                                                                                    id="tonnageMaterialId"
                                                                                    name="tonnageMaterialId"
                                                                                    placeholder='Material...'
                                                                                    options={materials}
                                                                                    value={(materials ?? []).find((s) => s.value === detail.tonnageMaterialId) ?? ''}
                                                                                    onChange={(
                                                                                        ev,
                                                                                    ) => this.onMaterialChange(
                                                                                        detail.resources,
                                                                                        ev,
                                                                                    )}
                                                                                >
                                                                                </Select>
                                                                                <div style={{ height: '10px' }}>&nbsp;</div>
                                                                            </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>Gross</td>
                                                                            <td>&nbsp;</td>
                                                                            <td>&nbsp;</td>
                                                                            <td colspan='2'>
                                                                                <input
                                                                                    disabled={disabled}
                                                                                    id="tonnageGross"
                                                                                    name="tonnageGross"
                                                                                    className={cls(
                                                                                        'form-control form-control-sm',
                                                                                    )}
                                                                                    style={{ textAlign: 'right' }}
                                                                                    value={
                                                                                        detail.tonnageGross
                                                                                        ?? '0'
                                                                                    }
                                                                                    onFocus={(e) => {
                                                                                        e.currentTarget.select();
                                                                                    }}
                                                                                    onChange={(
                                                                                        ev,
                                                                                    ) => this.onTonnageChange(
                                                                                        detail.resources,
                                                                                        ev,
                                                                                    )}
                                                                                />
                                                                            </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>Tare</td>
                                                                            <td>&nbsp;</td>
                                                                            <td>&nbsp;</td>
                                                                            <td colspan='2'>
                                                                                <input
                                                                                    disabled={disabled}
                                                                                    id="tonnageTare"
                                                                                    name="tonnageTare"
                                                                                    className={cls(
                                                                                        'form-control form-control-sm',
                                                                                    )}
                                                                                    style={{ textAlign: 'right' }}
                                                                                    value={
                                                                                        detail.tonnageTare
                                                                                        ?? '0'
                                                                                    }
                                                                                    onFocus={(e) => {
                                                                                        e.currentTarget.select();
                                                                                    }}
                                                                                    onChange={(
                                                                                        ev,
                                                                                    ) => this.onTonnageChange(
                                                                                        detail.resources,
                                                                                        ev,
                                                                                    )}
                                                                                />
                                                                            </td>
                                                                        </tr>

                                                                        <tr>
                                                                            <td>Net</td>
                                                                            <td>&nbsp;</td>
                                                                            <td>&nbsp;</td>
                                                                            <td colspan='2'>
                                                                                <input
                                                                                    disabled={disabled}
                                                                                    id="tonnageNet"
                                                                                    name="tonnageNet"
                                                                                    className={cls(
                                                                                        'form-control form-control-sm',
                                                                                    )}
                                                                                    style={{ textAlign: 'right' }}
                                                                                    value={
                                                                                        detail.tonnageNet
                                                                                        ?? '0'
                                                                                    }
                                                                                    onFocus={(e) => {
                                                                                        e.currentTarget.select();
                                                                                    }}
                                                                                    onChange={(
                                                                                        ev,
                                                                                    ) => this.onTonnageChange(
                                                                                        detail.resources,
                                                                                        ev,
                                                                                    )}
                                                                                />
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )}

                                                            </>
                                                        );
                                                    },
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                ),
                            )}

                        <FlexStartRow>
                            <FormGroup className="w-100">
                                <FormLabel htmlFor="notes" text="Notes" />
                                <textarea
                                    disabled={disabled}
                                    placeholder="(Optional, limit 2000 characters)"
                                    maxLength="2000"
                                    id="notes"
                                    rows="3"
                                    name="timesheet.notes"
                                    className={cls(
                                        'form-control form-control-sm',
                                    )}
                                    value={timesheet.notes ?? ''}
                                    onChange={(ev) => {
                                        const { value } = ev.target;
                                        this.setState(
                                            (state) => (
                                                (state.timesheet.notes = value),
                                                state
                                            ),
                                        );
                                    }}
                                />
                                <small
                                    className={cls('text-right', {
                                        'text-danger': notesLength < 0,
                                        'text-success': notesLength >= 0,
                                    })}
                                >
                                    {`${(
                                        2000 - notesLength
                                    ).toString()} remaining`}
                                </small>
                            </FormGroup>
                        </FlexStartRow>
                    </div>
                </SlideForm>
                <AddressFormNew
                    id="addressForm"
                    ref={this.addressFormRef}
                    contractUsesPrevailingWage
                    onSaveCallback={(address) => this.onSaveAddress(address)}
                />

                <Modal
                    isOpen={
                        showTimeModal
                    }>
                    <ModalBody>
                        <FlexCenterRow>
                            <FormGroup style={{ marginBottom: '12px', width: '100%', maxWidth: '260px' }}>
                                {(() => {
                                    // The dropdown offers two choices: the job date and
                                    // the day after. Start time is locked to the job
                                    // date, so the dropdown is disabled for it. End
                                    // time is editable so an entry can span two days.
                                    // Parse with UTC to avoid timezone shifts changing
                                    // the calendar day — both option values and the
                                    // selected value in state must agree on the day.
                                    const jobDateRaw = this.state.timesheet?.jobDate;
                                    const jobDate = jobDateRaw
                                        ? moment.utc(jobDateRaw).format('YYYY-MM-DD')
                                        : moment().format('YYYY-MM-DD');
                                    const nextDate = moment(jobDate).add(1, 'day').format('YYYY-MM-DD');
                                    const jobDateLabel = moment(jobDate).format('ddd, MMM D, YYYY');
                                    const nextDateLabel = moment(nextDate).format('ddd, MMM D, YYYY');
                                    // Snap selectedDate to one of the two valid options.
                                    // If state holds an unrelated value (e.g. legacy data),
                                    // default to jobDate so the dropdown shows a real choice.
                                    const current = this.state.selectedDate;
                                    const value = current === nextDate ? nextDate : jobDate;
                                    // If state isn't already one of the two canonical
                                    // options, commit the snapped value so what the user
                                    // sees is what gets saved (endDateForSave reads state,
                                    // not this displayed value). Deferred to avoid a
                                    // setState-during-render warning.
                                    if (current !== value) {
                                        setTimeout(
                                            () => this.setState({ selectedDate: value }),
                                            0,
                                        );
                                    }
                                    return (
                                        <>
                                            <FormLabel htmlFor="selectedDate" text="Date" required />
                                            <Input
                                                id="selectedDate"
                                                name="selectedDate"
                                                type="select"
                                                value={value}
                                                onChange={(ev) => {
                                                    const { value } = ev.target;
                                                    this.setState({ selectedDate: value });
                                                }}
                                            >
                                                <option value={jobDate}>{jobDateLabel}</option>
                                                <option value={nextDate}>{nextDateLabel}</option>
                                            </Input>
                                        </>
                                    );
                                })()}
                            </FormGroup>
                        </FlexCenterRow>
                        {(() => {
                            const jobDateRaw = this.state.timesheet?.jobDate;
                            const jobDate = jobDateRaw
                                ? moment.utc(jobDateRaw).format('YYYY-MM-DD')
                                : moment().format('YYYY-MM-DD');
                            const nextDate = moment(jobDate).add(1, 'day').format('YYYY-MM-DD');
                            const crossesMidnight = this.state.selectedDate === nextDate;
                            if (!crossesMidnight) return null;
                            return (
                                <FlexCenterRow>
                                    <div
                                        className="d-flex align-items-center mb-3 p-3"
                                        style={{
                                            color: '#856404',
                                            backgroundColor: '#fff3cd',
                                            border: '1px solid #ffeeba',
                                            borderRadius: '0.25rem',
                                            fontSize: '1rem',
                                            width: '100%',
                                            maxWidth: '420px',
                                        }}
                                    >
                                        <FontAwesomeIcon
                                            icon={faExclamationTriangle}
                                            className="mr-2"
                                            style={{ fontSize: '1.5rem' }}
                                        />
                                        <span>
                                            This date crosses midnight into the next day.
                                        </span>
                                    </div>
                                </FlexCenterRow>
                            );
                        })()}
                        <FlexCenterRow>
                            <table style={{ width: '100px' }}>
                                <tr>
                                    <td>
                                        <table >
                                            <tr>
                                                <td align="center">
                                                    <div>
                                                        <i onClick={(e) => this.onIncrementHours(e)} style={{ fontSize: '50px' }} className="fa fa-caret-up"></i>
                                                    </div>
                                                    <div>
                                                        <Input
                                                            value={this.state.selectedHour}
                                                            style={{ width: '50px', textAlign: 'center', padding: 0 }}
                                                            type="number"
                                                            step={1}
                                                            min={1}
                                                            max={12}
                                                            onFocus={(e) => {
                                                                e.currentTarget.select();
                                                            }}
                                                            onChange={(ev) => {
                                                                var { value } = ev.target;

                                                                if (value > 12)
                                                                    value = 12;
                                                                if (value < 1)
                                                                    value = 1;

                                                                this.setState(
                                                                    (state) => (
                                                                        (state.selectedHour = value),
                                                                        state
                                                                    ),
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <i onClick={(e) => this.onDecrementHours(e)} style={{ fontSize: '50px' }} className="fa fa-caret-down"></i>
                                                    </div>
                                                </td>
                                                <td width="20">&nbsp;</td>
                                                <td align="center">
                                                    <div>
                                                        <i onClick={(e) => this.onIncrementMinutes(e)} style={{ fontSize: '50px' }} className="fa fa-caret-up"></i>
                                                    </div>
                                                    <div>
                                                        <Input
                                                            value={this.state.selectedMinutes}
                                                            style={{ width: '50px', textAlign: 'center', padding: 0 }}
                                                            type="number"
                                                            step={15}
                                                            min={0}
                                                            max={45}
                                                            onFocus={(e) => {
                                                                e.currentTarget.select();
                                                            }}
                                                            onChange={(ev) => {
                                                                var { value } = ev.target;

                                                                if (value < 0)
                                                                    value = 0;
                                                                else if (value >= 15 && value < 30)
                                                                    value = 15;
                                                                else if (value >= 30 && value < 45)
                                                                    value = 30;
                                                                else if (value >= 45)
                                                                    value = 45;

                                                                this.setState(
                                                                    (state) => (
                                                                        (state.selectedMinutes = value),
                                                                        state
                                                                    ),
                                                                );

                                                            }}
                                                        />
                                                    </div>
                                                    <div>
                                                        <i onClick={(e) => this.onDecrementMinutes(e)} style={{ fontSize: '50px' }} className="fa fa-caret-down"></i>
                                                    </div>
                                                </td>
                                            </tr>
                                        </table>
                                    </td>
                                    <td width="20">&nbsp;</td>
                                    <td>
                                        <table>
                                            <tr>
                                                {AMPM == 'AM' &&
                                                    <td><Button color="success">AM</Button></td>
                                                }
                                                {AMPM != 'AM' &&
                                                    <td><Button onClick={() => this.onAMPM('AM')} color="secondary">AM</Button></td>
                                                }
                                            </tr>
                                            <tr><td></td></tr>
                                            <tr>
                                                {AMPM == 'PM' &&
                                                    <td><Button color="success">PM</Button></td>
                                                }
                                                {AMPM != 'PM' &&
                                                    <td><Button onClick={() => this.onAMPM('PM')} color="secondary">PM</Button></td>
                                                }
                                            </tr>
                                        </table>
                                    </td>
                                </tr>
                            </table>
                        </FlexCenterRow>
                    </ModalBody>
                    <ModalFooter>
                        <FlexStartRow>
                            <Button
                                color="primary"
                                onClick={(e) => this.onClearTime()}
                            >
                                Clear
                            </Button>
                        </FlexStartRow>

                        <FlexEndRow>
                            <Button
                                color="secondary"
                                onClick={(e) => this.onCancelTime()}
                            >
                                Cancel
                            </Button>
                            &nbsp;&nbsp;
                            <Button
                                color="success"
                                onClick={(e) => this.onSubmitTime()}
                            >
                            OK
                            </Button>
                        </FlexEndRow>
                    </ModalFooter>
                </Modal>

                <Modal
                    isOpen={
                        showDeleteTimesheetModal
                    }
                    toggle={
                        this.toggleDeleteTimesheetModal
                    }
                >
                    <ModalHeader
                        toggle={
                            this.toggleDeleteTimesheetModal
                        }
                    >
                        Remove Ticket
                    </ModalHeader>
                    <ModalBody>
                        <FormGroup>
                            <p className="text-danger">
                                Are you sure you wish to remove this ticket?
                            </p>
                        </FormGroup>
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="danger"
                            onClick={
                                this.onDeleteTimesheet
                            }
                        >
                            Remove
                        </Button>
                        {' '}
                        <Button
                            color="secondary"
                            onClick={
                                this.toggleDeleteTimesheetModal
                            }
                        >
                            Cancel
                        </Button>
                        {' '}
                    </ModalFooter>
                </Modal>
            </>
        );
    }
}
